const directionUrl = (origin, store) => {
  return `https://www.google.com/maps/dir/?api=1` + `&origin=${origin.lat},${origin.lng}`
    + `&destination=${store.lat},${store.lng}` + `&travelmode=${store.distance > 1 ? 'driving' : 'walking'}`;
};

export default directionUrl;
